module.exports = __webpack_public_path__ + "static/media/Service.704296f5.png";